<template>
    <div>
        <div class="container">
        <br />
       
       
      <div v-if="team" >
       
      <br />
      <div class="seasoncast-card" v-bind:style="'border-left: 3px solid '+team.color+';'">
      <h3>{{ team.name}}</h3><small> {{ team.sport}} | {{ team.owner.name}}</small>
     
     </div>
     <br />
      <h5>Recent Events</h5><hr />
<div v-if="eventList" class="row">

  <div class="col-md-6 p-2" v-for="event in eventList" v-bind:key="event.id" >
      <event :event="event" :channel_id="event.associated.id" @clicked="locateRecording(event.associated.id,event.id)" >
    </event> 
</div>
</div>
<br />
      <div  class=" "> 
             <br />
                     <h5>Recent Community Highlights</h5><hr />
                        <div class="p-1">

    <div v-if="highlightList && highlightList.length == 0">
        No Recent Highlights. 
    </div>
    <div v-if="highlightList" class="row">
    <div  v-for="highlight in highlightList" v-bind:key="highlight.id" class=" col-md-3 col-12 p-2">
        <div class="cardDisplay" style="cursor:pointer;" @click="$router.push('/highlight/'+highlight.id)" >
        <img style="width:100%; height:auto; border-radius:5px;margin-bottom:10px" v-bind:src="'https://cdn.mylivegame.com/file/mylivegame/highlights/'+highlight.publisher.id+'/'+highlight.id+'/thumbnail.jpg'" />
        <h5 v-text="highlight.title"></h5>
        {{ highlight.origin.title}}
       </div>
    </div>
    </div>
     </div>
             </div>

      </div>
      <div v-else>
          <p>Team is loading...</p>
      </div>
    </div>
    <br />
</div>
</template>


<script>
import axios from "axios"
import Swal from "sweetalert2"
import event from '../components/Event.vue'
   //import cookie from "cookie.js"

let API = "https://app.seasoncast.com/"
//let API = "http://localhost:8089/"

export default { 
  name: 'TeamWatch',
  components: {
   event
  },
  
  data: function () {
    return {

        team_id: this.$route.params.team_id,
        team: undefined,
        highlightList: undefined,
        eventList: undefined,

    }
  },

  created: async function () {
   
 document.title = "Team - SeasonCast"
await this.getTeam()
 document.title = this.team ?  this.team.name +" - SeasonCast" : "Team - SeasonCast" 


 this.getTeamEvents()
  this.getHighlights()
  },

  methods: {

   getTeam: async function () {

      let getResponse = await axios.post(API+ "v2/team", {
     
    team_id: this.team_id,

  }) 

  let responseData = getResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData)
this.team = responseData.result
   },
     getHighlights: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/team/highlights", {
    team_id: this.team_id,
    
  }) 

  let responseData = getEventResponse.data

  
console.log("highlights",responseData)
  this.highlightList = responseData.result



    },
    locateRecording: async function(channel_id, event_id){
    var eventSel =  await this.getChannelEvent(channel_id, event_id)

    if (!eventSel){
  return
    }

  this.$router.push("/"+channel_id+"/recording/"+eventSel.recordings[0].session) 
    },
      getChannelEvent: async function (channel_id, event_id) {
      
    let getEventResponse = await axios.post(API+ "v2/channel/event", {
    channel_id: channel_id,
    event_id: event_id
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData)
  return responseData.eventData
  


    },
       getTeamEvents: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/team/events", {
  team_id: this.team_id,
  }) 

  let responseData = getEventResponse.data
this.isLoaded = true

console.log(responseData)
  this.eventList =  responseData.result
    


    },
  }
}

</script>
<style lang="css" scoped>
    .cardDisplay {
          border-style: solid;
  border-width: 1px;
   border-radius: 5px;
   border-color: rgb(226, 226, 226);
   padding: 10px;
   text-align: center;
   background-color: white;
    }
    </style>>